"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
//@ts-ignore
require("../theme.ts");
var Nav = /** @class */ (function (_super) {
    __extends(Nav, _super);
    function Nav() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._preSelected = null;
        _this.toggle = function (evt, id, open) {
            evt.stopPropagation();
            _this.fire('toggle', { id: id, open: open });
        };
        _this.onNodeClick = function (id) {
            _this.fire('nodeClick', { id: id, pre: _this._preSelected });
        };
        return _this;
    }
    Nav.prototype.renderNode = function (node, level) {
        var _this = this;
        if (node.selected) {
            this._preSelected = node.id;
        }
        var next = level + 1;
        return omi_1.h("ul", null,
            omi_1.h("li", { class: omi_1.classNames('tree-item', {
                    'close': node.close
                }) },
                omi_1.h("span", { onClick: function (_) { return _this.onNodeClick(node.id); }, style: "padding-left: " + (level * 24 + 10) + "px;", class: omi_1.classNames('mdc-tree-title', {
                        'selected': node.selected
                    }) },
                    node.icon && omi_1.h("i", { class: 'material-icons' }, node.icon),
                    omi_1.h("span", { class: 'text' }, node.title),
                    node.children && node.children.length > 0 && omi_1.h("svg", { onClick: function (_) { return _this.toggle(_, node.id, !node.close); }, viewBox: "0 0 1024 1024", class: "arrow", "data-icon": "caret-down", width: "1em", height: "1em", fill: "currentColor", "aria-hidden": "true", focusable: "false" },
                        omi_1.h("path", { d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" }))),
                omi_1.h("div", { class: 'children', style: "height: " + (node.close ? 0 : (node.children ? (this._getChildCount(node)) * 40 : 0)) + "px;" },
                    " ",
                    node.children && node.children.length > 0 && node.children.map(function (_) { return _this.renderNode(_, next); }))));
    };
    Nav.prototype._getChildCount = function (node) {
        var _this = this;
        var count = 0;
        if (node.children && !node.close) {
            count += node.children.length;
            node.children.forEach(function (child) {
                count += _this._getChildCount(child);
            });
        }
        return count;
    };
    Nav.prototype.render = function (props) {
        var _this = this;
        return omi_1.h("div", { class: 'm-nav' }, props.nodes.map(function (node) { return _this.renderNode(node, 0); }));
    };
    Nav.css = css;
    Nav.propTypes = {
        nodes: Object
    };
    Nav = __decorate([
        omi_1.tag('m-nav')
    ], Nav);
    return Nav;
}(omi_1.WeElement));
exports.default = Nav;
